export default __webpack_public_path__ + "static/montserrat-v14-latin-regular-0eb53b51fdb5c7aaf601d9b9ed1cabff.eot";